import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TemplatePage from './pages/TemplatePage';
import VideoTemplatePage from './pages/VideoTemplatePage';
import CategoryPage from './pages/CategoryPage';
import CarouselPage from './pages/CarouselPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/image/templates" element={<TemplatePage />} />
      <Route path="/video/templates" element={<VideoTemplatePage />} />
      <Route path="/categories" element={<CategoryPage />} />
      <Route path="/carousel" element={<CarouselPage />} />
    </Routes>
  );
}

export default AppRoutes;
